exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".itemWell{\r\n  margin-top: 20px;\r\n  width: 255px;\r\n  margin-left: 5%;\r\n  background-color: white;\r\n  box-shadow: 2px 2px 15px 2px;\r\n}\r\n.currentLocationItem{\r\n  width: 300px;\r\n  margin: auto;\r\n  font-size: 25px;\r\n  /*color: gray;*/\r\n  color: #fff;\r\n}\r\n.locationDivider{\r\n  /*border-top: 1px solid aqua;*/\r\n  border-top: 1px solid #df776f;\r\n  width: 150px;\r\n}\r\n#itemsSection{\r\n  margin-top: 60px;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/pkwoy/Desktop/progressive-webb-app/src/app/dash-board/dash-board.component.css
// module id = ../../../../../src/app/dash-board/dash-board.component.css
// module chunks = main